/**
 * The vehicle fields a description is built from. Deliberately looser than `Vehicle`: federation
 * vehicles (for example Blue assets created without a year) arrive with any of these parts null even
 * where the model types them as required.
 */
export interface VehicleDescriptionParts {
    year?: number | string | null;
    make?: string | null;
    model?: string | null;
}

/**
 * Builds a "year make model" description, skipping any part that is missing or blank so a vehicle
 * without a year reads "MAZDA CX-9" rather than "null MAZDA CX-9".
 *
 * @param vehicle - The vehicle to describe; a missing vehicle yields an empty string.
 * @returns The non-empty parts joined by single spaces, or an empty string when none remain.
 */
export function formatVehicleDescription(vehicle: VehicleDescriptionParts | null | undefined): string {
    if (!vehicle) {
        return '';
    }

    const parts = [vehicle.year, vehicle.make, vehicle.model];
    const presentParts: string[] = [];

    for (const part of parts) {
        if (part === null || part === undefined) {
            continue;
        }

        const text = String(part).trim();
        if (text !== '') {
            presentParts.push(text);
        }
    }

    return presentParts.join(' ');
}
